import React from "react";
import AddIcon from "@mui/icons-material/Add";
import Controls from "src/components/form/controls/Controls";
import { CACHE_ICON } from "src/constants/actionCache";
import DeployCache, {
  isShowCache,
} from "src/components/deployCache/DeployCache";
import { useState } from "react";
import ShowCacheFLFIcon from "../ShowCache/ShowCacheFLFIcon";
import { allowedToCreateEntity } from "src/constants/role";
import { Link } from "react-router-dom";
import { path } from "src/constants/path";
import useAuth from "src/hooks/useAuth";

const FLFIconControlPanel = ({
  permissionsAccessControl,
  children,
  isSorted,
  handleSort,
  currentActionCache,
  page,
  iconType,
  limit,
}) => {
  const { auth } = useAuth();
  const [disableButton, setDisableButton] = useState(false);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>{children}</div>
      <div>
        <DeployCache
          title="Cache Icon"
          isShowButton={isShowCache(currentActionCache, CACHE_ICON)}
        >
          <ShowCacheFLFIcon
            disableButton={disableButton}
            setDisableButton={setDisableButton}
          />
        </DeployCache>
        {isSorted ? (
          <Controls.Button
            text="Apply sort"
            variant="outlined"
            onClick={handleSort}
          />
        ) : null}
        {allowedToCreateEntity(auth?.permissions, permissionsAccessControl) && (
          <Link
            to={{
              pathname: `${path.flfIcon}/add`,
              state: { page: page, iconType: iconType, limit: limit },
            }}
          >
            <Controls.Button
              text="Add New"
              variant="outlined"
              startIcon={<AddIcon />}
            />
          </Link>
        )}
      </div>
    </div>
  );
};

export default FLFIconControlPanel;
